import Seo from "@/components/feature/Seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { generalFaqs, siteMeta } from "@/mocks/site";
import { topics } from "@/mocks/topics";
import HeroSection from "./components/HeroSection";
import HotRanking from "./components/HotRanking";
import CategoryGrid from "./components/CategoryGrid";
import LatestReviews from "./components/LatestReviews";
import EvidenceSpotlight from "./components/EvidenceSpotlight";
import ReversalTimeline from "./components/ReversalTimeline";
import FaqPreview from "./components/FaqPreview";
import CtaBand from "./components/CtaBand";

const origin = "https://youhuochigua.example";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteMeta.name,
    url: origin,
    description: siteMeta.description,
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: `${origin}/topics?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteMeta.name,
    url: origin,
    description: siteMeta.description,
    email: siteMeta.email,
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "诱惑吃瓜 今日热榜",
    itemListElement: topics.slice(0, 5).map((topic, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `${origin}/topics/${topic.id}`,
      name: topic.title,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: generalFaqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="诱惑吃瓜 - 实锤证据 反转辟谣 真相全复盘"
        description={siteMeta.description}
        keywords={siteMeta.keywords}
        path="/"
        image="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20theater%20stage%20with%20deep%20crimson%20velvet%20curtains%20and%20warm%20golden%20spotlight%20beams%20cutting%20through%20floating%20dust%2C%20dramatic%20mysterious%20atmosphere%2C%20wide%20editorial%20composition%20with%20dark%20vignette%20edges%20for%20text%20overlay%2C%20rich%20shadows%2C%20high%20detail%2C%20no%20people&width=1800&height=1100&seq=guada-hero-01&orientation=landscape"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main>
        <HeroSection />
        <HotRanking />
        <CategoryGrid />
        <LatestReviews />
        <EvidenceSpotlight />
        <ReversalTimeline />
        <FaqPreview />
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}